import { render, staticRenderFns } from "./freeWord.vue?vue&type=template&id=6b9e81fc&scoped=true&"
import script from "./freeWord.vue?vue&type=script&lang=js&"
export * from "./freeWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9e81fc",
  null
  
)

export default component.exports